export default "__VITE_ASSET__8fffecd3__"